import workBench from '@/router/router-list/work-bench.js'
import securityBasis from '@/router/router-list/security-basis.js';
import work from '@/router/router-list/work.js';
import education from '@/router/router-list/education.js';
import dualPreControl from '@/router/router-list/dual-pre-control.js';
import manage from '@/router/router-list/manage.js';
import emergencyManage from '@/router/router-list/emergency-manage.js';
import equipment from '@/router/router-list/equipment.js';
import smartInspection from '@/router/router-list/smart-inspection.js';

export default [workBench, securityBasis, equipment, work, education, dualPreControl, manage, emergencyManage,smartInspection ];
